<template>
  <div class="mark-message">
    <AppScrollbar style="height: 100%"
                  v-loading="loading"
                  element-loading-text="消息加载中，请稍等...">
      <div class="message-cont"
           v-infinite-scroll="loadMoreMessage"
           infinite-scroll-disabled="noMore"
           infinite-scroll-distance="30"
           infinite-scroll-immediate-check="false"
           infinite-scroll-listen-for-event="loadMoreEvent">
        <template v-if="messageList">
          <MessageTimeline v-if="messageList.length"
                           :message-list="messageList"></MessageTimeline>
          <Hint v-else
                v-show="noMore && !loadingMore">
            <span>暂时没有标记消息</span>
          </Hint>
          <div class="message-loader" v-if="!noMore">
            <span v-if="loadingMore">
              <i class="el-icon-loading"></i>
              <span>更多数据加载中...</span>
            </span>
            <el-button v-else
                       size="mini"
                       type="text"
                       @click="loadMoreMessage">加载更多...</el-button>
          </div>
        </template>
        <Hint v-else
              v-show="!loading">
          <span>用户消息加载失败</span>
          <a class="theme-text" @click="loadMessage">重新加载</a>
        </Hint>
      </div>
    </AppScrollbar>
  </div>
</template>

<script>
import AppScrollbar from '../elements/AppScrollbar'
import Hint from '../elements/Hint'
import MessageTimeline from './timeline/MessageTimeline'
import MessageLoader from '../../mixins/message/loader'
import messageEvent from '../../constants/messageEvent'
export default {
  name: 'MarkMessage',
  mixins: [MessageLoader],
  components: {
    AppScrollbar,
    Hint,
    MessageTimeline
  },
  props: {
    visible: Boolean
  },
  methods: {
    queryMessage () {
      let prevId
      if (this.messageList && this.messageList.length) {
        prevId = this.messageList[this.messageList.length - 1].id
      }
      return this.$ajax({
        url: '/support/message/biz/notification/mark',
        method: 'post',
        data: this.$qs.stringify({
          prevId: prevId || ''
        })
      })
    },
    onReadMessage (message) {
      let messageList = this.messageList
      if (messageList) {
        messageList.filter(item => item.id === message.id)
          .forEach(item => {
            this.$set(item, 'isRead', 1)
          })
      }
    },
    onMarkMessage (message) {
      let messageList = this.messageList
      if (messageList) {
        messageList.unshift(message)
      }
    },
    onUnmarkMessage (message) {
      let messageList = this.messageList
      if (messageList) {
        messageList.filter(item => item.id === message.id)
          .forEach(item => {
            let index = messageList.indexOf(item)
            if (index >= 0) {
              messageList.splice(index, 1)
            }
          })
      }
    },
    onDeleteMessage (message) {
      let messageList = this.messageList
      if (messageList) {
        messageList.filter(item => item.id === message.id)
          .forEach(item => {
            let index = messageList.indexOf(item)
            if (index >= 0) {
              messageList.splice(index, 1)
            }
          })
      }
    },
    onSetAllRead () {
      let messageList = this.messageList
      if (messageList) {
        messageList.filter(item => !item.isRead)
          .forEach(item => {
            this.$set(item, 'isRead', 1)
          })
      }
    }
  },
  created () {
    this.$bus.$on(messageEvent.subscribe.READ_MESSAGE, this.onReadMessage)
    this.$bus.$on(messageEvent.subscribe.MARK_MESSAGE, this.onMarkMessage)
    this.$bus.$on(messageEvent.subscribe.UNMARK_MESSAGE, this.onUnmarkMessage)
    this.$bus.$on(messageEvent.subscribe.DELETE_MESSAGE, this.onDeleteMessage)
    this.$bus.$on(messageEvent.subscribe.SET_ALL_MESSAGE_READ, this.onSetAllRead)
  },
  mounted () {
    this.loadMessage()
  },
  beforeDestroy () {
    this.$bus.$off(messageEvent.subscribe.READ_MESSAGE, this.onReadMessage)
    this.$bus.$off(messageEvent.subscribe.MARK_MESSAGE, this.onMarkMessage)
    this.$bus.$off(messageEvent.subscribe.UNMARK_MESSAGE, this.onUnmarkMessage)
    this.$bus.$off(messageEvent.subscribe.DELETE_MESSAGE, this.onDeleteMessage)
    this.$bus.$off(messageEvent.subscribe.SET_ALL_MESSAGE_READ, this.onSetAllRead)
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.$nextTick(() => this.handleLoadMoreEvent())
      }
    }
  }
}
</script>

<style lang="scss">
  .mark-message {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    .message-cont {
      .layout-hint {
        height: 300px;
      }
      & > .message-loader {
        margin-top: 10px;
        height: 30px;
        font-size: 12px;
        text-align: center;
        line-height: 30px;
        i {
          font-size: 18px;
          vertical-align: -2px;
        }
      }
    }
  }
</style>
